export default "__VITE_ASSET__f687d9a3__"